<template>
    <div class="dingdan">
<!--        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'经销商签收'}]" v-if="firstPageFlag!=1"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="订单编号" style="width: 50%;">
                            <el-input v-model="formInline.sapCodeLike" placeholder="多订单模糊查询请用空格分隔"></el-input>
                        </el-form-item>
                        <el-form-item label="　物料编码/名称">
                            <el-input v-model="formInline.materialCode" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="  是否签收">
                            <el-select v-model="formInline.thawStatus"
                                       placeholder="请选择"
                                       clearable>
                                <el-option label="已签收" value="Y"></el-option>
                                <el-option label="未签收" value="N"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="  SAP过账">
                        <el-select v-model="formInline.pgiStatus"
                                   placeholder="请选择"
                                   clearable>
                            <el-option label="是" value="Y"></el-option>
                            <el-option label="否" value="N"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                    <el-collapse-transition>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="　　到货日期" class="ddqlcpicker" style="width: 50%;">
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.dStartDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.dEndDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="　　签收日期" class="ddqlcpicker" style="width: 50%;">
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.aStartDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.aEndDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="　售达方编码/名称" prop="agentCode">
                                        <el-input v-model="formInline.agentCode" placeholder="请输入"
                                                  style="width: 100%"></el-input>
                                    </el-form-item>
                                    <el-form-item label="地区" prop="soldToAreaCode">
                                        <brselect clearable category="YLRegion" :v="formInline.soldToAreaCode"
                                                  v-model="formInline.soldToAreaCode"></brselect>
                                    </el-form-item>
                                    <el-form-item label="签收日期(oms)" class="ddqlcpicker" style="width: 50%;">
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.aOmsStartDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.aOmsEndDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="  自产/OEM">
                                        <el-select v-model="formInline.proType"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="自产" value="自产"></el-option>
                                            <el-option label="OEM" value="OEM"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="销售渠道" prop="customerChannelCode">
                                        <brselect clearable category="sales_region" :v="formInline.customerChannelCode"
                                                  v-model="formInline.customerChannelCode"></brselect>
                                    </el-form-item>
                                    <el-form-item label="是否直单用户">
                                        <el-select v-model="formInline.isZhidan"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="　订单类型" prop="orderCategory1">
                                        <el-select v-model="formInline.orderCategory1" clearable placeholder="请选择" style="width:100%">
                                            <el-option v-for="item in orderCategory1List"
                                                       :key="item.code"
                                                       :label="item.name"
                                                       :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
<!--                                    <el-form-item label="  直发/库发">-->
<!--                                        <el-select v-model="formInline.zhifakufa"-->
<!--                                                   placeholder="请选择"-->
<!--                                                   clearable>-->
<!--                                            <el-option label="直发" value="1"></el-option>-->
<!--                                            <el-option label="库发" value="2"></el-option>-->
<!--                                        </el-select>-->
<!--                                    </el-form-item>-->
                                </div>
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="自动化冷库" v-if="lkfjFlag">
                                        <el-select v-model="formInline.isZdlk"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="销售组织" prop="saleGroupCode">
                                        <brselect category="xiaoshou_zuzhi" :v="formInline.gscode" :showcode="true"
                                                  v-model="formInline.gscode" clearable></brselect>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-collapse-transition>
                    </el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-mrt30 margin">
            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">每月的最后一天中午12点至次日凌晨4点为系统禁止签收时间，不可进行签收操作！</h6>
<!--            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">2022年4月签收截止日期为4月29日中午12点,请及时签收！</h6>-->
        </div>
        <div class="h-table h-mrt30">
            <el-table
                    @selection-change="handleSelectionChange"
                    ref="ddtable"
                    :data="tableData"
                    stripe
                    border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
                    max-height="520"
            >
                <el-table-column
                        type="selection"
                        width="40"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                        type="index"
                        label="#"
                        fixed>
                </el-table-column>
                <el-table-column
                        prop="sapCode"
                        label="销售订单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="thawStatus"
                        label="签收状态"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
                        <span v-if="scope.row.thawStatus == 'N'">未签收</span>
                        <span v-if="scope.row.thawStatus == 'Y'">已签收</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderCategory1"
                        label="订单类型"
                        :show-overflow-tooltip="true"
                        width="100">
                    <template scope="scope">
                        {{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="gscode"
                        label="销售组织"
                        :show-overflow-tooltip="true"
                        width="260">
                    <template scope="scope">
                        <div style="text-align: left;">
                            [{{scope.row.gscode}}]{{scope.row.gscode|dictname('YLSalesOrganization_agent')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品大类"
                        v-if="this.showDalei"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品名称"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="customerChannelName"
                        label="销售渠道"
                        :show-overflow-tooltip="true"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="agentName"
                        label="售达方名称"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="soldToAreaName"
                        label="地区"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="toCompanyname"
                        label="收货单位"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="count"
                        label="数量"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="unitPrice"
                        label="单价"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="totalPrice"
                        label="总价"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="deliveryDate"
                        label="到货日期"
                        :formatter="formatDate"
                        value-format="yyyy-MM-dd"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="acceptDate"
                        :formatter="formatDate"
                        value-format="yyyy-MM-dd"
                        width="100">
                    <template slot="header">
                        <div style="line-height:18px;text-align:center;">
                            签收日期<br/>(售后)
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="acceptDateOms"
                        :formatter="formatDate"
                        value-format="yyyy-MM-dd"
                        width="100">
                    <template slot="header">
                        <div style="line-height:18px;text-align:center;">
                            签收日期<br/>(OMS)
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="signUserName"
                        label="签收人"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
                        <span>{{scope.row.signUserName || scope.row.signUser}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proType"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template slot="header">
                        <div style="line-height:18px;text-align:center;">
                            自产/<br/>OEM
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="pgiStatus"
                        label="SAP过账"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
                        <span v-if="scope.row.pgiStatus == 'Y'">是</span>
                        <span v-if="scope.row.pgiStatus =='N'">否</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="isZdlk"
                        label="自动化冷库"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
                        <span v-if="scope.row.isZdlk == 1">是</span>
                        <span v-if="scope.row.isZdlk == 0">否</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="isZdlk"
                        label="直单用户"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
                        <span v-if="scope.row.isZhidan == 1">是</span>
                        <span v-if="scope.row.isZhidan == 0">否</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="isQrqs"
                        label="套餐确认签收"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
                        <span v-if="scope.row.isQrqs == 1">是</span>
                        <span v-if="scope.row.isQrqs == 0">否</span>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                        prop="zhifakufa"-->
<!--                        label="直发/库发"-->
<!--                        :show-overflow-tooltip="true"-->
<!--                        width="80">-->
<!--                    <template scope="scope">-->
<!--                        <span v-if="scope.row.zhifakufa == '1'">直发</span>-->
<!--                        <span v-if="scope.row.zhifakufa == '2'">库发</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="160"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.thawStatus == 'N' && (dlsFlag || adminFlag) && scope.row.acceptFlag == true && scope.row.isZdlk == 0 && scope.row.isZhidan == 0 && scope.row.deliveryDate
                                    && scope.row.orderCategory1 != '12' && scope.row.orderCategory1 != '9' && scope.row.gscode != '1R60' && scope.row.gscode != '1S00' && scope.row.gscode != '1S40'
                                    && scope.row.gscode != '1S30' && scope.row.gscode != '44U0' && (scope.row.pgiStatus == 'Y' || (scope.row.orderCategory1 == '43' || scope.row.orderCategory1 == '8'))"
                                    @click="tosapKaipiao(scope.row)">签收
                            </el-button>
                            <!--自动化冷库直单签收-->
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.isZdlk == 1 && scope.row.isZhidan == 1  && scope.row.acceptFlag == true && scope.row.thawStatus == 'N' && scope.row.canSign
                                    &&  scope.row.orderCategory1 != '12'&&  scope.row.orderCategory1 != '9' && scope.row.gscode != '1R60' && scope.row.gscode != '1S00' && scope.row.gscode != '1S40'
                                    && scope.row.gscode != '1S30' && scope.row.gscode != '44U0' && (scope.row.pgiStatus == 'Y' || (scope.row.orderCategory1 == '43' || scope.row.orderCategory1 == '8'))"
                                    @click="sendTokaipLkZd(scope.row)">签收
                            </el-button>
                            <!--自动化冷库非直单签收-->
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.isZdlk == 1 && scope.row.isZhidan == 0  && scope.row.acceptFlag == true && zdlkFlag && scope.row.thawStatus == 'N' && scope.row.canSign
                                    &&  scope.row.orderCategory1 != '12'&&  scope.row.orderCategory1 != '9' && scope.row.gscode != '1R60' && scope.row.gscode != '1S00' && scope.row.gscode != '1S40'
                                    && scope.row.gscode != '1S30' && scope.row.gscode != '44U0' && (scope.row.pgiStatus == 'Y' || (scope.row.orderCategory1 == '43' || scope.row.orderCategory1 == '8'))"
                                    @click="sendTokaipLk(scope.row)">签收
                            </el-button>
                            <!--直单经销商专用签收-->
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.isZhidan == 1 && scope.row.isZdlk == 0 && scope.row.acceptFlag == true && scope.row.thawStatus == 'N' && scope.row.orderCategory1 != '12' && scope.row.canSign
                                    && scope.row.orderCategory1 != '9' && scope.row.gscode != '1R60' && scope.row.gscode != '1S00' && scope.row.gscode != '1S40' && scope.row.gscode != '1S30'
                                    && scope.row.gscode != '44U0' && (scope.row.pgiStatus == 'Y' || (scope.row.orderCategory1 == '43' || scope.row.orderCategory1 == '8'))"
                                    @click="sendTokaipZd(scope.row)">签收
                            </el-button>

                            <!-- 服务订单签收按钮 -->
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.orderCategory1 == '9' && scope.row.acceptFlag == true && scope.row.thawStatus == 'N' && scope.row.orderCategory1 != '12'
                                    && scope.row.gscode != '1R60' && scope.row.gscode != '1S00' && scope.row.gscode != '1S40' && scope.row.gscode != '1S30' && scope.row.gscode != '44U0'
                                    && (scope.row.materialCode && scope.row.materialCode.toUpperCase().startsWith('BE') ? scope.row.pgiStatus == 'Y' : true)"
                                    @click="sendTokaipFw(scope.row)">签收
                            </el-button>

                            <!-- 康盛签收按钮 -->
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.acceptFlag == true && scope.row.thawStatus == 'N'&& scope.row.gscode == '1R60' && xiaoshouKs
                                    && (scope.row.materialCode && scope.row.materialCode.toUpperCase().startsWith('BE') ? scope.row.pgiStatus == 'Y' : true)"
                                    @click="tosapKaipiao(scope.row)">签收
                            </el-button>

                            <!-- 厚宏,元析签收按钮 -->
                            <el-button
                                size="small" class="h-tableLink h-btn"
                                v-if="scope.row.orderCategory1 != '12' && scope.row.orderCategory1 != '15' && scope.row.acceptFlag == true && (scope.row.pgiStatus == 'Y' || (scope.row.orderCategory1 == '43' || scope.row.orderCategory1 == '8'))
                                && scope.row.thawStatus == 'N' && (scope.row.gscode == '1S00' || scope.row.gscode == '1S40' || scope.row.gscode == '1S30' || scope.row.gscode == '44U0' )"
                                @click="sendTokaipHhYx(scope.row)">签收
                            </el-button>

                            <!-- 厚宏,元析服务签收按钮 -->
                            <el-button
                                size="small" class="h-tableLink h-btn"
                                v-if="scope.row.orderCategory1 == '9' && scope.row.orderCategory1 != '12' && scope.row.acceptFlag == true && scope.row.thawStatus == 'N'
                                    && (scope.row.gscode == '1S00' || scope.row.gscode == '1S40' || scope.row.gscode == '1S30' || scope.row.gscode == '44U0' )
                                    && (scope.row.materialCode && scope.row.materialCode.toUpperCase().startsWith('BE') ? scope.row.pgiStatus == 'Y' : true)"
                                @click="sendTokaipHhYx(scope.row)">签收
                            </el-button>

                            <!-- 元析组合订单签收按钮 -->
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.orderCategory1 == '15' && scope.row.acceptFlag == true && scope.row.isPackage == 0 && scope.row.thawStatus == 'N'
                                    && scope.row.pgiStatus == 'Y' && (scope.row.gscode == '44U0' )"
                                    @click="sendTokaipHhYx(scope.row)">签收
                            </el-button>

                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="canViewAttachment(scope.row)"
                                    @click="viewAttachment(scope.row)">查看附件
                            </el-button>
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="(scope.row.orderCategory1 == '12' || scope.row.orderCategory1 == '15')  && scope.row.isQrqs == 0 && scope.row.isPackage == 1 && (dlsFlag || adminFlag)
                                    && scope.row.acceptFlag == true"
                                    @click="confirmAccept(scope.row)">签收确认
                            </el-button>
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.orderCategory1 == '12' && scope.row.gscode != '44U0'  && scope.row.thawStatus == 'N' && scope.row.isQrqs == 1 && scope.row.pgiStatus == 'Y'
                                    && (tcGly||adminFlag||isHh||isYx) && scope.row.acceptFlag == true"
                                    @click="packageInvoice(scope.row)">套餐开票
                            </el-button>
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.orderCategory1 == '12' && scope.row.gscode != '44U0'  && scope.row.thawStatus == 'N' && adminFlag && scope.row.pgiStatus == 'Y' && scope.row.acceptFlag == false"
                                    @click="packageInvoice(scope.row)">管理员套餐开票
                            </el-button>
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="(scope.row.orderCategory1 == '12' || scope.row.orderCategory1 == '15')   && scope.row.thawStatus == 'N'
                                    && scope.row.gscode == '44U0' && scope.row.isPackage == 1 && scope.row.isQrqs == 1 && scope.row.pgiStatus == 'Y' && (tcGly||adminFlag||isHh||isYx) && scope.row.acceptFlag == true"
                                    @click="packageInvoiceYx(scope.row)">套餐开票
                            </el-button>
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="(scope.row.orderCategory1 == '12' || scope.row.orderCategory1 == '15')   && scope.row.thawStatus == 'N'
                                    && scope.row.gscode == '44U0' && scope.row.isPackage == 1 && scope.row.isQrqs == 1 && adminFlag && scope.row.pgiStatus == 'Y' && scope.row.acceptFlag == false"
                                    @click="packageInvoiceYxNotTime(scope.row)">管理员套餐开票
                            </el-button>
                            <el-button v-if="scope.row.instid != null && scope.row.instid != ''  && (scope.row.isZdlk == 1 || scope.row.isZhidan == 1)"
                                       size="small" class="h-tableLink h-btn"
                                       @click="genzongLiuch(scope.row.instid)">
                                跟踪
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                <pagination :page="formInline" @query="query"/>
                <div style="display:flex;align-items: center;">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="exportExcel" v-if="!isShield">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="(dlsFlag || adminFlag)"
                               @click="sendTosapKaipiao">批量签收
                    </el-button>
<!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="(tcGly || adminFlag) && isDateFlag"
                               @click="acceptPackage">套餐批量签收
                    </el-button>-->
                </div>
            </div>
            <!-- 流程跟踪图 -->
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
            <!--附件管理-批量上传入货通知-->
            <el-dialog
                    :visible.sync="showLkkaipiao"
                    v-if="showLkkaipiao"
                    class="h-dialog2"
            >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>上传签收资料</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">订单号:</h3>
                    <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
                    <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应的签收资料，单据以“订单号+单据名称”命名，以上信息完整方可签收</h6>
                </div>
                <div class="h-formLine" style="padding:20px;">
                    <h3 style="display: inline-block;">签收资料</h3>
                    <brupload
                            style="margin-top: 0.1rem;"
                            @filecallback="DJKPStatus"
                            :refid="this.ddhB"
                            reftype="NX_ZDLK"
                            :uploadflag = "fjFlag"
                            :delflag = "!(this.ks == 'Y')"/>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitFujianC">提 交</el-button>
                </div>
            </el-dialog>
            <el-dialog
                    :visible.sync="showZdkaipiao"
                    v-if="showZdkaipiao"
                    class="h-dialog2"
            >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>上传签收资料</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">订单号:</h3>
                    <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
                    <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应的签收资料，单据以“订单号+单据名称”命名，以上信息完整方可签收</h6>
                    <br/>
                    <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">注：直单客户合同约定验收的请上传对应的合格验收单</h6>
                    <br/>
                    <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">直单附件请上传双方盖章的合同及合同约定的签收单/验收单,谢谢</h6>

                </div>
                <div class="h-formLine" style="padding:20px;">
                    <h3 style="display: inline-block;">签收资料</h3>
                    <brupload
                            style="margin-top: 0.1rem;"
                            @filecallback="DJKPStatus"
                            :refid="this.ddhB"
                            reftype="NX_ZD"
                            :uploadflag = "fjFlag"
                            :delflag = "!(this.ks == 'Y')"/>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelZd">取 消</el-button>
                    <el-button class="h-btn h-bBtn" v-if="this.ddGs != '0PN0'" @click="submitFujianC">提 交</el-button>
                    <el-button class="h-btn h-bBtn" v-if="this.ddGs == '0PN0'" @click="submitFujianD">提 交</el-button>
                </div>
            </el-dialog>
            <el-dialog
                    :visible.sync="showLkZdkaipiao"
                    v-if="showLkZdkaipiao"
                    class="h-dialog2"
            >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>上传签收资料</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">订单号:</h3>
                    <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
                    <br/>
                    <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应的签收资料，单据以“订单号+单据名称”命名，以上信息完整方可签收</h6>
                </div>
                <div class="h-formLine" style="padding:20px;">
                    <h3 style="display: inline-block;">冷库签收资料</h3>
                    <brupload
                            style="margin-top: 0.1rem;"
                            @filecallback="DJKPStatus"
                            :refid="this.ddhB"
                            reftype="NX_ZDLK"
                            :uploadflag = "fjFlag"
                            :delflag = "!(this.ks == 'Y')"/>
                </div>
                <div class="h-formLine" style="padding:20px;">
                    <h3 style="display: inline-block;">直单签收资料</h3>
                    <br/>
                    <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">直单附件请上传双方盖章的合同及合同约定的签收单/验收单,谢谢</h6>
                    <brupload
                            style="margin-top: 0.1rem;"
                            @filecallback="DJKPStatus"
                            :refid="this.ddhB"
                            reftype="NX_ZD"
                            :uploadflag = "fjFlag"
                            :delflag = "!(this.ks == 'Y')"/>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitFujianC">提 交</el-button>
                </div>
            </el-dialog>
            <!-- 统一附件查看弹窗 -->
            <el-dialog
                :visible.sync="unifiedAttachmentVisible"
                v-if="unifiedAttachmentVisible"
                class="h-dialog2"
            >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>查看签收附件</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">订单号:</h3>
                    <h4 style="display: inline-block;margin-left: 0.1rem;">{{refid}}</h4>
                </div>
                <div v-if="unifiedAttachmentRow.isZdlk == 1" class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">冷库签收资料</h3>
                    <brupload
                        style="margin-top: 0.1rem;"
                        @filecallback="DJKPStatus"
                        :refid="refid"
                        reftype="NX_ZDLK"
                        :uploadflag="fjFlag"
                        :delflag="!(this.ks == 'Y')"/>
                </div>
                <div v-if="unifiedAttachmentRow.isZhidan == 1 && unifiedAttachmentRow.isZdlk == 0" class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">直单签收资料</h3>
                    <brupload
                        style="margin-top: 0.1rem;"
                        @filecallback="DJKPStatus"
                        :refid="refid"
                        reftype="NX_ZD"
                        :uploadflag="fjFlag"
                        :delflag="!(this.ks == 'Y')"/>
                </div>
                <div v-if="unifiedAttachmentRow.orderCategory1 == '9'" class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">服务签收资料</h3>
                    <brupload
                        style="margin-top: 0.1rem;"
                        @filecallback="DJKPStatus"
                        :refid="refid"
                        reftype="NXFW_QSZL"
                        :uploadflag="fjFlag"
                        :delflag="!(this.ks == 'Y')"/>
                </div>
                <div v-if="unifiedAttachmentRow.orderCategory1 == '12' || unifiedAttachmentRow.orderCategory1 == '15'" class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">套餐签收资料</h3>
                    <brupload
                        style="margin-top: 0.1rem;"
                        :refid="refid"
                        reftype="NX_TC"
                        :delflag="!(this.ks == 'Y')"/>
                </div>
                <div v-if="unifiedAttachmentRow.orderCategory1 != '12' && (unifiedAttachmentRow.gscode == '1S00' || unifiedAttachmentRow.gscode == '1S40' || unifiedAttachmentRow.gscode == '1S30' || unifiedAttachmentRow.gscode == '44U0')" class="h-formLine" style="padding:20px;">
                    <h3 style="display: inline-block;">厚宏/元析签收资料</h3>
                    <brupload
                        style="margin-top: 0.1rem;"
                        :refid="refid"
                        reftype="NXHH_QSZL"
                        :delflag="!(this.ks == 'Y')"/>
                </div>
            </el-dialog>
            <!--厚宏，元析签收页面-->
            <el-dialog
                :visible.sync="showHhYxkaipiao"
                v-if="showHhYxkaipiao"
                class="h-dialog2"
            >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>上传签收资料</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">订单号:</h3>
                    <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
                    <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应的签收资料，单据以“订单号+单据名称”命名，以上信息完整方可签收</h6>
                </div>
              <div class="h-formLine n-two">
                <el-form  v-if="null != bscContractHhxm && isHHxm" :model="bscContractHhxm" ref="form1"
                          :inline="true" class="h-formbLine weiuheuw" >
                  <el-form-item prop="startTime" label="质保开始时间"
                                :rules="[{ required: true, message: '请先选择质保开始日期', trigger: 'blur'},]">
                      <el-date-picker v-model="bscContractHhxm.startTime" type="date" :clearable="false"
                          placeholder="--请先选择质保开始日期--" value-format="yyyy-MM-dd">
                      </el-date-picker>
                  </el-form-item>
                  <el-form-item prop="endTime" label="质保结束时间"
                                :rules="[{ required: true, message: '请先选择质保结束日期', trigger: 'blur'},]">
                      <el-date-picker v-model="bscContractHhxm.endTime" type="date" :clearable="false"
                          placeholder="--请先选择质保结束日期--" value-format="yyyy-MM-dd">
                      </el-date-picker>
                  </el-form-item>
                </el-form>
              </div>
                <div class="h-formLine" style="padding:20px;">
                    <h3 style="display: inline-block;">签收资料</h3>
                    <brupload
                        style="margin-top: 0.1rem;"
                        @filecallback="DJKPStatus"
                        :refid="this.ddhB"
                        reftype="NXHH_QSZL"
                        :uploadflag = "fjFlag"
                        :delflag = "!(this.ks == 'Y')"/>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelHhYx">取 消</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitFujianDHhxm">提 交</el-button>
                </div>
            </el-dialog>


            <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="packageInvoiceFlag" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>套餐开票</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;" class="dialogout X-dai">
                        <el-form :model="package" label-position="right" :inline="true" label-width="150"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <el-form-item label="开票方式:" style="width: 50%;" prop="invoiceFlage">
                                <el-switch
                                        v-model="package.invoiceFlag"
                                        active-text="整套"
                                        inactive-text="组件">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="套餐订单号" class="h-elformWrap-4" disabled prop="packageOrderCode">
                                <el-input v-model="package.packageOrderCode" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="套餐名称" class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="package.packageName"></el-input>
                            </el-form-item>
                            <el-form-item label="税号" v-if="package.invoiceFlag" disabled class="h-elformWrap-4" prop="pacakgeName">
                                <el-input v-model="package.taxCode"></el-input>
                            </el-form-item>
                            <el-form-item label="规格/型号" v-if="package.invoiceFlag" disabled class="h-elformWrap-4" prop="pacakgeName">
                                <el-input v-model="package.sceneName"></el-input>
                            </el-form-item>
                            <el-form-item label="套餐数量"  class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="package.packageNum" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="套餐总价" class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="package.packageTotalPrice" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="签收资料" class="h-elformWrap-4" disabled prop="qsFile" required>
                                <brupload
                                        @filecallback="DJKPStatus"
                                        :refid="refid"
                                        reftype="NX_TC"
                                        :uploadflag = "fjFlag"
                                        :showTime="false"
                                        :showtime="false"
                                        :delflag = "!(this.ks == 'Y')"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialog">取 消</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitInvoice">提 交</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitInvoiceNoTime" v-if="adminFlag">不限时间提交</el-button>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="packageInvoiceYxFlag" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>套餐开票</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;" class="dialogout X-dai">
                        <el-form :model="packageYx" label-position="right" :inline="true" label-width="150"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <el-form-item label="开票方式:" style="width: 50%;" prop="invoiceYxFlage">
                                <el-switch
                                        v-model="packageYx.invoiceFlag"
                                        active-text="整套"
                                        inactive-text="组件">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="套餐订单号" class="h-elformWrap-4" disabled prop="packageOrderCode">
                                <el-input v-model="packageYx.packageOrderCode" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="套餐名称" class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="packageYx.packageName"></el-input>
                            </el-form-item>
                            <el-form-item label="税号" v-if="packageYx.invoiceFlag" disabled class="h-elformWrap-4" prop="pacakgeName">
                                <el-input v-model="packageYx.taxCode"></el-input>
                            </el-form-item>
                            <el-form-item label="规格/型号" v-if="packageYx.invoiceFlag" disabled class="h-elformWrap-4" prop="pacakgeName">
                                <el-input v-model="packageYx.sceneName"></el-input>
                            </el-form-item>
                            <el-form-item label="套餐数量"  class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="packageYx.packageNum" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="套餐总价" class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="packageYx.packageTotalPrice" disabled></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialog">取 消</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitInvoiceYx">提 交</el-button>
                    <el-button class="h-btn h-bBtn" @click="packageInvoiceKaiPiao" v-if="adminFlag">仅开票</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitInvoiceYxJk" v-if="adminFlag">解冻加开票</el-button>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="packageInvoiceYxFlagNotTime" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>套餐开票</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;" class="dialogout X-dai">
                        <el-form :model="packageYx" label-position="right" :inline="true" label-width="150"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <el-form-item label="开票方式:" style="width: 50%;" prop="invoiceYxFlage">
                                <el-switch
                                        v-model="packageYx.invoiceFlag"
                                        active-text="整套"
                                        inactive-text="组件">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="套餐订单号" class="h-elformWrap-4" disabled prop="packageOrderCode">
                                <el-input v-model="packageYx.packageOrderCode" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="套餐名称" class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="packageYx.packageName"></el-input>
                            </el-form-item>
                            <el-form-item label="税号" v-if="packageYx.invoiceFlag" disabled class="h-elformWrap-4" prop="pacakgeName">
                                <el-input v-model="packageYx.taxCode"></el-input>
                            </el-form-item>
                            <el-form-item label="规格/型号" v-if="packageYx.invoiceFlag" disabled class="h-elformWrap-4" prop="pacakgeName">
                                <el-input v-model="packageYx.sceneName"></el-input>
                            </el-form-item>
                            <el-form-item label="套餐数量"  class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="packageYx.packageNum" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="套餐总价" class="h-elformWrap-4" disabled prop="pacakgeName">
                                <el-input v-model="packageYx.packageTotalPrice" disabled></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialog">取 消</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitInvoiceYxNotTime">签收并开票</el-button>
                    <el-button class="h-btn h-bBtn" @click="packageInvoiceKaiPiao">仅开票</el-button>
                </div>
            </el-dialog>

            <el-dialog
                    :visible.sync="showFwkaipiao"
                    v-if="showFwkaipiao"
                    class="h-dialog2"
            >
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>内销服务订单解冻签收凭证总览</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                    <h3 style="display: inline-block;">订单号:</h3>
                    <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
                    <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应签收资料，单据以“订单号+单据名称”命名，以上信息完整方可开票</h6>
                </div>
                <div class="h-formLine" style="padding:20px;">
                    <h3 style="display: inline-block;">签收资料</h3>
                    <brupload
                            style="margin-top: 0.1rem;"
                            @filecallback="DJKPStatus"
                            :refid="this.ddhB"
                            reftype="NXFW_QSZL"
                            :uploadflag = "fjFlag"
                            :delflag = "!(this.ks == 'Y')"/>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                    <el-button class="h-btn h-bBtn" @click="submitFujianD">提 交</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';

    export default {
        props: ["firstPageFlag"],
        data() {
            return {
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                instid: null,
                tableData: [],
                multipleSelection: [],
                adminFlag:false,
                xiaoshouKs:false,
                isHh:false,
                isYx:false,
                dlsFlag:false,
                tcGly:false,
                isDateFlag:false,
                isDateTcFlag:false,
                all: '全部',
                showLkZdkaipiao: false, //冷库直单
                showLkkaipiao: false, //冷库
                showZdkaipiao: false, //直单
                showFwkaipiao: false, //服务
                showHhYxkaipiao: false, //厚宏,元析
                isShield:false,//法务屏蔽导出
                showhistory:false,
                fjFlag: null,
                ks: "N",
                ddhB: null,
                ddGs:null,
                bscContractHhxm:null,
                isHHxm:false,
                zdlkFlag: false,
                codeId: null,
                formInline: {
                    sapCodeLike: '',
                    materialCode:'',
                    isAccept:'',
                    dStartDate:'',
                    dEndDate:'',
                    aStartDate: '',
                    aEndDate: '',
                    aOmsStartDate: '',
                    aOmsEndDate:'',
                    thawStatus:'N',
                    pgiStatus:'',
                    soldToAreaCode:'',
                    agentCode:'',
                    proType:'',
                    customerChannelCode: '',
                    isZdlk: '',
                    isLk: '',
                    isPackage: '0',
                    packageOrderCode: '',
                    isZhidan:'',
                    orderCategory1:'',
                    gscode:'',

                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                lkfjFlag: false,
                unifiedAttachmentVisible: false,
                unifiedAttachmentRow: {},
                refid: null,
                packageInvoiceFlag: false,
                packageInvoiceYxFlag: false,
                packageInvoiceYxFlagNotTime: false,
                tcData: {
                    packageOrderCode:null,
                    packageCode:null,
                },
                package:{
                    invoiceFlag:false,
                    packageOrderCode:null,
                    packageCode:null,
                    packageName:null,
                    invoiceType:'',
                    packageNum: 0,
                    packageTotalPrice: 0,
                    taxCode: null,
                    sceneName:null,
                    sceneCode:null,
                    factory:null,
                    gscode:null,
                },
                packageYx:{
                    invoiceFlag:true,
                    packageOrderCode:null,
                    packageCode:null,
                    packageName:null,
                    invoiceType:'',
                    packageNum: 0,
                    packageTotalPrice: 0,
                    taxCode: null,
                    sceneName:null,
                    sceneCode:null,
                    factory:null,
                    gscode:null,
                },
                showDalei:true,
                kpTypeFlag:false,
                orderCategory1AllList:[],
                orderCategory1List:[],
            }
        },
        created() {
            this.query();
            // this.isDate();
            if (this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('suoyouliebiaochakan') || this.$store.getters.hasRole('fapiaogly')) {
                this.adminFlag = true;
            }
            if (this.$store.getters.hasRole('swyl_gndailishang') || this.$store.getters.hasRole('86dailishang') || this.$store.getters.hasRole('swyl_dingdgly_hsj')
                || this.$store.getters.hasRole('hh_shichangneiqin') || this.$store.getters.hasRole('yx_shichangneiqin')   || this.$store.getters.hasRole('yx_shouhoujl')
                || this.$store.getters.hasRole('swyl_dingdgly')
            ) {
                this.dlsFlag = true;
            }
            if (this.$store.getters.hasRole('hh_shichangneiqin')) {
                this.isHh = true;
            }
            if (this.$store.getters.hasRole('yx_shichangneiqin')) {
                this.isYx = true;
            }
            if(this.$store.getters.hasRole('lk_qianshou')){
                this.zdlkFlag = true;
            }
            if(this.$store.getters.hasRole('lk_chakanfujian')||this.$store.getters.hasRole('swyl_admin') ||this.$store.getters.hasRole('lk_qianshou') || this.$store.getters.hasRole('suoyouliebiaochakan')){
                this.lkfjFlag = true;
            }
            if(this.$store.getters.hasRole('tcqs_admin')){
                this.tcGly = true;
                this.formInline.isPackage = 1;
                this.formInline.orderCategory1 = '12';
            }
            if (this.$store.getters.hasRole('swyl_fawu')) {
              this.isShield = true;
            }
            if (this.$store.getters.hasRole('swyl_xiaoshoujl_kangsheng') ||this.$store.getters.hasRole('swyl_admin')) {
                this.xiaoshouKs = true;
            }
            // this.isDateTc();
            this.orderCategory1AllList=this.$store.getters.dictlist("xiaoshou_quyu_nwx");
            this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:'201910254L3O3bAL'});
        },
        methods: {
            // 展开折叠
            collapseChange() {
                this.isScreen = !this.isScreen;
            },
            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //重置
            resetData() {
                this.formInline.sapCodeLike='';
                this.formInline.materialCode='';
                this.formInline.isAccept='';
                this.formInline.dStartDate='';
                this.formInline.dEndDate='';
                this.formInline.aStartDate='';
                this.formInline.aEndDate='';
                this.formInline.aOmsStartDate='';
                this.formInline.aOmsEndDate='';
                this.formInline.thawStatus='';
                this.formInline.pgiStatus='';
                this.formInline.soldToAreaCode='';
                this.formInline.agentCode='';
                this.formInline.proType='';
                this.formInline.customerChannelCode= '';
                this.formInline.isZdlk='';
                this.formInline.isZhidan='';
                this.formInline.isPackage = '0';
                this.formInline.packageOrderCode = '';
                this.formInline.orderCategory1 = '';
            },
            //获取数据
            query() {
                //自动化冷库角色只看冷库订单
                if(this.$store.getters.hasRole('lk_qianshou')){
                    this.formInline.isZdlk = 1;
                }
                if(this.$store.getters.hasRole('tcqs_admin')){
                    this.formInline.isPackage = 1;
                    this.formInline.orderCategory1 = '12';
                }
                ss.OrderMainService.orderKaipioaPage(this.formInline).then(rd =>{
                    this.tableData = rd.records;
                    this.formInline.total = rd.total || 0;
                    if(this.formInline.isPackage == 1){
                        this.showDalei = false;
                    }else if(this.formInline.isPackage == 0){
                        this.showDalei = true;
                    }
                })
            },
            //判断当前日期是否在允许签收的时间范围之内
            // isDate(){
            //     ss.OrderMainService.isDate().then(rd =>{
            //         this.isDateFlag = rd.msg;
            //     })
            // },
            //判断当前日期是否在允许签收的时间范围之内
            // isDateTc(){
            //     ss.OrderMainService.isDateTc().then(rd =>{
            //         this.isDateTcFlag = rd.msg;
            //     })
            // },
            //申请解冻开票
            sendTosapKaipiao() {
                var ids = [];
                var flag1 = false
                var flag2 = false
                var flag3 = false
                var flag4 = false
                var flag5 = false
                var flag6 = false
                var flag7 = false
                var flag8 = false
                var flag9 = false
                var flag10 = false
                var flag11 = false
                this.multipleSelection.forEach((item, index) => {
                    if(item.isAccept != 1){
                        flag1 = true;
                        return;
                    }
                    if(item.add2 == null){
                        flag3 = true;
                        return;
                    }
                    if(item.thawStatus == 'Y'){
                        flag4 = true;
                        return;
                    }
                    if(item.isZdlk == 1){
                        flag5 = true;
                        return;
                    }
                    if(item.deliveryDate == null || item.deliveryDate == ''){
                        flag6 = true;
                        return;
                    }
                    if(item.isZhidan == 1){
                        flag7 = true;
                        return;
                    }
                    if(item.orderCategory1 == '9'){
                        flag8 = true;
                        return;
                    }
                    if(item.orderCategory1 == '12'){
                        flag9 = true;
                        return;
                    }
                    if(item.gscode == '1S00' || item.gscode == '1S40' || item.gscode == '1S30'){
                        flag10 = true;
                        return;
                    }
                    if(item.gscode == '44U0'){
                        flag11 = true;
                        return;
                    }
                })
                if(flag1){
                    this.$msg.msge("选择的订单必须都是已签收状态才可开票！");
                    return;
                }
                if(flag4){
                    this.$msg.msge("选择的订单中包含已签收的订单！");
                    return;
                }
                if(flag3){
                    this.$msg.msge("sap订单号不能为空！");
                    return;
                }
                if(flag5){
                    this.$msg.msge("自动化冷库订单需上传签收附件才可签收！");
                    return;
                }
                if(flag6){
                    this.$msg.msge("到货日期为空的订单不可签收！");
                    return;
                }
                if(flag7){
                    this.$msg.msge("直单用户订单签收需上传签收附件，不可批量签收！");
                    return;
                }
                if(flag8){
                    this.$msg.msge("服务订单签收需上传签收附件，不可批量签收！");
                    return;
                }
                if(flag9){
                    this.$msg.msge("套餐订单不可批量签收！");
                    return;
                }
                if(flag10){
                    this.$msg.msge("厚宏订单需上传签收附件，不可批量签收！");
                    return;
                }
                if(flag11){
                    this.$msg.msge("元析订单需上传签收附件，不可批量签收！");
                    return;
                }

                var flag12 = false
                this.multipleSelection.forEach((item, index) => {
                    // 服务订单：仅物料编码以 BE 开头时才校验 pgiStatus
                    var needCheck = true;
                    if (item.orderCategory1 == '9') {
                        needCheck = item.materialCode && item.materialCode.toUpperCase().startsWith('BE');
                    }
                    // 租赁订单：不校验 pgiStatus
                    if (item.orderCategory1 == '43' || item.orderCategory1 == '8') {
                        needCheck = false;
                    }
                    if (needCheck && item.pgiStatus != 'Y') {
                        flag12 = true;
                        return;
                    }
                })
                if (flag12) {
                    this.$msg.msge("选择的订单中包含 SAP 未过账的订单，不可批量签收！");
                    return;
                }

                this.multipleSelection.forEach((item, index) => {
                    ids.push(item.id);
                })
                this.$msg.confirm("是否确认签收?", () => {
                    ss.OrderMainService.sendTosapKaipiao(ids).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });
            },
            //申请解冻开票
            tosapKaipiao(val) {
                var ids = [];
                ids.push(val.id);
                this.$msg.confirm("是否确认签收?", () => {
                    ss.OrderMainService.sendTosapKaipiao(ids).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });
            },
            exportExcel() {
                //自动化冷库角色只看冷库订单
                if(this.$store.getters.hasRole('lk_qianshou')){
                    this.formInline.isZdlk = 1;
                }
                updownfile.down("/api/swyl/v1/demo/orderNxKaipiao/downloadExcel", this.formInline, "post");
            },
            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.multipleSelection.forEach(element => {
                    element.syNum = element.availableNum - element.proNumber;
                });
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null) {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            //冷库签收
            sendTokaipLk(val){
                if(val.isZdlk != 1){
                    this.$msg.msge("选中的订单必须为自动化冷库订单！");
                    return;
                }
                if(val.thawStatus == 'Y'){
                    this.$msg.msge("选中的订单必须为未签收的订单！");
                    return;
                }
                if(val.deliveryDate == "" || val.deliveryDate == null){
                    this.$msg.msge("到货日期为空的订单不可签收！");
                    return;
                }
                this.fjFlag = true;
                this.ks = val.thawStatus;
                this.ddhB = val.sapCode;
                console.log("ddhB",this.ddhB);
                this.codeId = val.id;
                this.showLkkaipiao = true;
            },
            //冷库直单签收
            sendTokaipLkZd(val){
                if(val.isZdlk != 1){
                    this.$msg.msge("选中的订单必须为自动化冷库订单！");
                    return;
                }
                if(val.isZhidan != 1){
                    this.$msg.msge("选中的订单必须为直单用户的订单！");
                    return;
                }
                if(val.thawStatus == 'Y'){
                    this.$msg.msge("选中的订单必须为未签收的订单！");
                    return;
                }
                if(val.deliveryDate == "" || val.deliveryDate == null){
                    this.$msg.msge("到货日期为空的订单不可签收！");
                    return;
                }
                this.fjFlag = true;
                this.ks = val.thawStatus;
                this.ddhB = val.sapCode;
                console.log("ddhB",this.ddhB);
                this.codeId = val.id;
                this.showLkZdkaipiao = true;
            },

            //直单签收
            sendTokaipZd(val){
                if(val.isZhidan != 1){
                    this.$msg.msge("选中的订单必须为直单用户的订单！");
                    return;
                }
                if(val.thawStatus == 'Y'){
                    this.$msg.msge("选中的订单必须为未签收的订单！");
                    return;
                }
                if(val.deliveryDate == "" || val.deliveryDate == null){
                    this.$msg.msge("到货日期为空的订单不可签收！");
                    return;
                }
                this.fjFlag = true;
                this.ks = val.thawStatus;
                this.ddhB = val.sapCode;
                this.ddGs = val.gscode;
                console.log("ddhB",this.ddhB);
                this.codeId = val.id;
                this.showZdkaipiao = true;
            },
            //服务订单签收
            sendTokaipFw(val){
                if(val.orderCategory1 != '9'){
                    this.$msg.msge("选中的订单必须为服务订单！");
                    return;
                }
                if(val.thawStatus == 'Y'){
                    this.$msg.msge("选中的订单必须为未签收的订单！");
                    return;
                }
                if(val.deliveryDate == "" || val.deliveryDate == null){
                    this.$msg.msge("到货日期为空的订单不可签收！");
                    return;
                }
                this.fjFlag = true;
                this.ks = val.thawStatus;
                this.ddhB = val.sapCode;
                console.log("ddhB",this.ddhB);
                this.codeId = val.id;
                this.showFwkaipiao = true;
            },

            //厚宏签收
            sendTokaipHhYx(val){
                if(val.gscode != '1S00' && val.gscode != '1S40' && val.gscode != '1S30' && val.gscode != '44U0' ){
                    this.$msg.msge("选中的订单公司必须为1S00或1S40或1S30或44U0！");
                    return;
                }
                if(val.thawStatus == 'Y'){
                    this.$msg.msge("选中的订单必须为未签收的订单！");
                    return;
                }
                this.fjFlag = true;
                this.ks = val.thawStatus;
                this.ddhB = val.sapCode;
                console.log("ddhB",this.ddhB);
                this.codeId = val.id;
              ss.OrderMainService.selectByCode(this.ddhB).then(rd => {
                if(rd.f == true && null != rd.obj){
                  this.bscContractHhxm = rd.obj;
                  this.isHHxm = true;
                }else {
                  this.bscContractHhxm = null;
                  this.isHHxm = false;
                }
              });
                this.showHhYxkaipiao = true;
            },

            DJKPStatus() {
                var data = this.ddhB;
                console.log("ddhB1",data);
                ss.OrderMainService.updateLkStatus(data).then(rd => {
                    if(rd.f == true){
                        // this.$msg.msgs("操作成功！");
                        // this.query();
                        // this.showFwkaipiao = false
                    }
                });
            },
            cancel() {
              this.showLkkaipiao = false;
              this.showFwkaipiao = false;
            },
            cancelZd() {
                this.showZdkaipiao = false;
            },
            cancelHhYx() {
                this.showHhYxkaipiao = false;
              this.bscContractHhxm = null;
              this.isHHxm = false;
            },

            //冷库签收启动审批 直单签收,直单冷库签收
            submitFujianC(){
                var ids = [];
                ids.push(this.codeId);
                console.log("codeId",ids);
                ss.OrderMainService.submitLKKaipiao(ids).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.showLkkaipiao = false;
                    this.showLkZdkaipiao = false;
                    this.showZdkaipiao = false;
                    this.query();
                });
            },
          submitFujianDHhxm(){
            var ids = [];
            ids.push(this.codeId);
            console.log("codeId",ids);
            if (this.isHHxm){
              this.$refs['form1'].validate((valid1) => {
                if (valid1 && this.isHHxm && null != this.bscContractHhxm) {
                  this.$msg.confirm("确认提交？", () => {
                    //更新质保时间

                    ss.OrderMainService.sendTosapKaipiao(ids).then(rd => {
                      if (rd.f){
                        ss.OrderMainService.updateById(this.bscContractHhxm).then(res => {

                        });
                      }
                      this.$msg.msgs(rd.msg);
                      this.showLkkaipiao = false;
                      this.showFwkaipiao = false;
                      this.showHhYxkaipiao = false;
                      this.bscContractHhxm = null;
                      this.isHHxm = false;
                      this.query();
                    });
                  })
                } else {
                  this.$msg.msge("请完善基本信息后提交");
                  return;
                }
              });
            }else {
              ss.OrderMainService.sendTosapKaipiao(ids).then(rd => {
                this.$msg.msgs(rd.msg);
                this.showLkkaipiao = false;
                this.showFwkaipiao = false;
                this.showHhYxkaipiao = false;
                this.bscContractHhxm = null;
                this.isHHxm = false;
                this.query();
              });
            }

          },
            submitFujianD(){
                var ids = [];
                ids.push(this.codeId);
                console.log("codeId",ids);
                ss.OrderMainService.sendTosapKaipiao(ids).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.showLkkaipiao = false;
                    this.showFwkaipiao = false;
                    this.showHhYxkaipiao = false;
                    this.query();
                });
            },
            canViewAttachment(row) {
                if (row.thawStatus != 'Y') return false;
                if (row.isZdlk == 1 && this.lkfjFlag && row.orderCategory1 != '12') return true;
                if (row.isZhidan == 1 && row.isZdlk == 0 && row.orderCategory1 != '12') return true;
                if (row.orderCategory1 == '9') return true;
                if ((row.orderCategory1 == '12' || row.orderCategory1 == '15') && (this.tcGly || this.adminFlag || this.isHh || this.isYx)) return true;
                if (row.orderCategory1 != '12' && (row.gscode == '1S00' || row.gscode == '1S40' || row.gscode == '1S30' || row.gscode == '44U0') && (this.tcGly || this.adminFlag || this.isHh || this.isYx)) return true;
                return false;
            },
            viewAttachment(o) {
                this.id = o.id;
                this.fjFlag = false;
                this.ks = o.thawStatus;
                this.refid = o.sapCode;
                this.unifiedAttachmentRow = o;
                this.unifiedAttachmentVisible = true;
            },

            /*
            seeFile(o) {
                this.id = o.id;
                this.refid = this.ddhU = o.sapCode;
                this.fjFlag = false;
                if(o.thawStatus == 'Y'){
                    this.ks = 'Y'
                }else{
                    this.ks = 'N'
                }
                this.showFujianD = true;
            },
            seeFile1(o) {
                this.id = o.id;
                this.refid = this.ddhU = o.sapCode;
                this.fjFlag = false;
                if(o.thawStatus == 'Y'){
                    this.ks = 'Y'
                }else{
                    this.ks = 'N'
                }
                this.showFujianZ = true;
            },
            seeFile3(o) {
                this.id = o.id;
                this.refid = o.sapCode;
                this.fjFlag = false;
                if(o.thawStatus == 'Y'){
                    this.ks = 'Y'
                }else{
                    this.ks = 'N'
                }
                this.showFujianF = true;
            },
            seeFile2(o) {
                this.id = o.id;
                this.refid = o.sapCode;
                this.fjFlag = false;
                if(o.thawStatus == 'Y'){
                    this.ks = 'Y'
                }else{
                    this.ks = 'N'
                }
                this.showFujianT = true;
            },
            seeFileHhYx(o) {
                this.id = o.id;
                this.refid = o.sapCode;
                this.fjFlag = false;
                if(o.thawStatus == 'Y'){
                    this.ks = 'Y'
                }else{
                    this.ks = 'N'
                }
                this.showFujianHhYx = true;
            },
            */

            //套餐订单确认签收
            confirmAccept(v) {
                var data = {};
                data.packageOrderCode = v.sapCode;
                data.packageCode = v.materialCode;
                ss.OrderMainService.confirmPackageAccept(data).then(rd => {
                    this.query();
                });
            },
/*            //套餐批量签收
            acceptPackage() {
                var flag1 = false
                this.multipleSelection.forEach((item, index) => {

                    if(item.isQrqs != 1){
                        flag1 = true;
                        return;
                    }
                })
                var tcList = [];
                this.multipleSelection.forEach((item, index) => {
                    this.tcData.packageCode = item.materialCode;
                    this.tcData.packageOrderCode = item.sapCode;
                    tcList.push(this.tcData)
                })
                ss.OrderMainService.tcSendToSapQs(tcList).then(rd => {
                    this.query();
                });

            },*/
            //开票弹窗
            packageInvoice(v) {

                var data = {};

                if(v.isQrqs != 1) {
                    this.$msg.msge("选择的订单必须都是用户确认签收的才可开票！");
                    return;
                }

                data.packageOrderCode = v.sapCode;
                data.packageCode = v.materialCode;

                this.fjFlag = true;
                this.ks = v.thawStatus;
                this.refid = v.sapCode;

                ss.OrderMainService.getPackageInfo(data).then(rd => {
                    this.package = rd.msg;
                    this.packageInvoiceFlag = true;
                });
            },
            //开票弹窗
            packageInvoiceYx(v) {
                var data = {};

                if(v.isQrqs != 1) {
                    this.$msg.msge("选择的订单必须都是用户确认签收的才可开票！");
                    return;
                }
                data.packageOrderCode = v.sapCode;
                data.packageCode = v.materialCode;

                this.fjFlag = true;
                this.ks = v.thawStatus;
                this.refid = v.sapCode;

                ss.OrderMainService.getPackageInfo(data).then(rd => {
                    this.packageYx = rd.msg;
                    this.packageYx.invoiceFlag = true;
                    //拆分星号
                   var arr = this.packageYx.packageName.split('*');

                   if(this.packageYx.packageName != null && this.packageYx.packageName != ''){
                       if(this.packageYx.packageName == "维修费"){
                           this.packageYx.invoiceFlag = false;
                       }
                       if(arr.length >= 2){
                           this.packageYx.packageName = arr[1];
                       }
                   }else {
                       if(arr.length >= 2){
                           this.packageYx.sceneName = arr[0];
                           this.packageYx.packageName = arr[1];
                       }
                   }
                    this.packageInvoiceYxFlag = true;
                });
            },
            //开票弹窗
            packageInvoiceYxNotTime(v) {
                var data = {};

                if(v.isQrqs != 1) {
                    this.$msg.msge("选择的订单必须都是用户确认签收的才可开票！");
                    return;
                }
                data.packageOrderCode = v.sapCode;
                data.packageCode = v.materialCode;

                this.fjFlag = true;
                this.ks = v.thawStatus;
                this.refid = v.sapCode;

                ss.OrderMainService.getPackageInfo(data).then(rd => {
                    this.packageYx = rd.msg;
                    this.packageYx.invoiceFlag = true;
                    //拆分星号
                    var arr = this.packageYx.packageName.split('*');

                    if(this.packageYx.packageName != null && this.packageYx.packageName != ''){
                        if(this.packageYx.packageName == "维修费"){
                            this.packageYx.invoiceFlag = false;
                        }
                        if(arr.length >= 2){
                            this.packageYx.packageName = arr[1];
                        }
                    }else {
                        if(arr.length >= 2){
                            this.packageYx.sceneName = arr[0];
                            this.packageYx.packageName = arr[1];
                        }
                    }
                    this.packageInvoiceYxFlagNotTime = true;
                });
            },
            //关闭弹框的事件
            closeDialog(){
                this.packageInvoiceFlag = false;
                this.packageInvoiceYxFlag = false;
                this.packageInvoiceYxFlagNotTime = false;
            },
            //开票提交方法
            submitInvoice() {
                var data = _.clone(this.package);
                if(this.package.invoiceFlag){
                    data.invoiceType = 'H';
                }else {
                    data.invoiceType = 'L';
                }
                // if(this.package.sceneCode != 'X02001' && this.package.sceneCode != 'X08001' && this.package.sceneCode != 'X02002'){
                //     if(data.invoiceType == 'L'){
                //         this.$msg.msge("只有智慧实验室场景、样本库方案场景、自动化大项目场景才可以以组件方式签收！");
                //         return;
                //     }
                // }
                ss.OrderMainService.tcInvoice(data).then(rd => {
                    this.packageInvoiceFlag = false;
                    this.query();
                });
            },
            //开票提交方法
            submitInvoiceNoTime() {
                var data = _.clone(this.package);
                if(this.package.invoiceFlag){
                    data.invoiceType = 'H';
                }else {
                    data.invoiceType = 'L';
                }
                // if(this.package.sceneCode != 'X02001' && this.package.sceneCode != 'X08001' && this.package.sceneCode != 'X02002'){
                //     if(data.invoiceType == 'L'){
                //         this.$msg.msge("只有智慧实验室场景、样本库方案场景、自动化大项目场景才可以以组件方式签收！");
                //         return;
                //     }
                // }
                ss.OrderMainService.tcInvoiceNotTime(data).then(rd => {
                    this.packageInvoiceFlag = false;
                    this.query();
                });
            },
            //开票提交方法
            submitInvoiceYx() {
                var data = _.clone(this.packageYx);
                if(this.packageYx.invoiceFlag){
                    data.invoiceType = 'H';
                }else {
                    data.invoiceType = 'L';
                }
                // if(this.package.sceneCode != 'X02001' && this.package.sceneCode != 'X08001' && this.package.sceneCode != 'X02002'){
                //     if(data.invoiceType == 'L'){
                //         this.$msg.msge("只有智慧实验室场景、样本库方案场景、自动化大项目场景才可以以组件方式签收！");
                //         return;
                //     }
                // }
                ss.OrderMainService.tcInvoice(data).then(rd => {
                    this.packageInvoiceYxFlag = false;
                    this.query();
                });
            },
            //开票提交方法
            submitInvoiceYxJk() {
                var data = _.clone(this.packageYx);
                if(this.packageYx.invoiceFlag){
                    data.invoiceType = 'H';
                }else {
                    data.invoiceType = 'L';
                }
                // if(this.package.sceneCode != 'X02001' && this.package.sceneCode != 'X08001' && this.package.sceneCode != 'X02002'){
                //     if(data.invoiceType == 'L'){
                //         this.$msg.msge("只有智慧实验室场景、样本库方案场景、自动化大项目场景才可以以组件方式签收！");
                //         return;
                //     }
                // }
                ss.OrderMainService.tcInvoiceJk(data).then(rd => {
                    this.packageInvoiceYxFlag = false;
                    this.query();
                });
            },

            //开票提交方法
            submitInvoiceYxNotTime() {
                var data = _.clone(this.packageYx);
                if(this.packageYx.invoiceFlag){
                    data.invoiceType = 'H';
                }else {
                    data.invoiceType = 'L';
                }
                // if(this.package.sceneCode != 'X02001' && this.package.sceneCode != 'X08001' && this.package.sceneCode != 'X02002'){
                //     if(data.invoiceType == 'L'){
                //         this.$msg.msge("只有智慧实验室场景、样本库方案场景、自动化大项目场景才可以以组件方式签收！");
                //         return;
                //     }
                // }
                ss.OrderMainService.tcInvoiceNotTime(data).then(rd => {
                    this.packageInvoiceYxFlagNotTime = false;
                    this.query();
                });
            },

            //开票提交方法
            packageInvoiceKaiPiao() {
                var data = _.clone(this.packageYx);
                if(this.packageYx.invoiceFlag){
                    data.invoiceType = 'H';
                }else {
                    data.invoiceType = 'L';
                }
                // if(this.package.sceneCode != 'X02001' && this.package.sceneCode != 'X08001' && this.package.sceneCode != 'X02002'){
                //     if(data.invoiceType == 'L'){
                //         this.$msg.msge("只有智慧实验室场景、样本库方案场景、自动化大项目场景才可以以组件方式签收！");
                //         return;
                //     }
                // }
                ss.OrderMainService.packageInvoiceKaiPiao(data).then(rd => {
                    this.packageInvoiceYxFlagNotTime = false;
                    this.query();
                });
            },
            genzongLiuch(r){
                this.instid = r;
                this.showhistory = true;
            },
        },
    }
</script>

<style scoped>
  .weiuheuw {
    margin-top:20px;
    ::v-deep .el-form-item__label{
      width: 130px;
    }
  }
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }

    /* 兼容 */
    /deep/ .h-formbLine .el-form-item__label{
        width:105px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }

</style>
<style>
    .ddqlcpicker .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 0;
    }
    .ddqlcpicker .el-range-editor.el-input__inner{
        padding-right: 0.12rem;
    }
</style>
